import axios from "axios";
import ConstantList from "../appConfig";

const API_PATH = ConstantList.API_EN_POINT_CRM + "/lead";

export const pagingLead = (searchObject) => axios.post(API_PATH + "/search-by-phone", searchObject);




